export default "__VITE_ASSET__BjkMe6fJ__"